const resolveApiUrl = () => {
  const isProduction = process.env.NODE_ENV === 'production';
  const envVarName = isProduction
    ? 'REACT_APP_API_URL_PROD'
    : 'REACT_APP_API_URL_DEV';
  const apiUrl = (process.env as Record<string, string | undefined>)[envVarName];

  if (!apiUrl) {
    if (typeof console !== 'undefined') {
      console.error(
        `[env] Missing ${envVarName}. Define it in the client .env file for the ` +
          `${isProduction ? 'production' : 'development'} build. Falling back to an empty API_URL.`,
      );
    }

    return '';
  }

  return apiUrl;
};

export default {
  API_URL: resolveApiUrl(),
  REGISTRATION_DISABLED: process.env.REACT_APP_REGISTRATION_DISABLED === '1',
  SUPPORT_EMAIL: process.env.REACT_APP_SUPPORT_EMAIL,
  TELEGRAM_BOT_LINK: process.env.REACT_APP_TELEGRAM_BOT_LINK,
  TELEGRAM_BOT_NAME: process.env.REACT_APP_TELEGRAM_BOT_NAME,
  YANDEX_METRIKA_ID: process.env.REACT_APP_YANDEX_METRIKA_ID,
  MARKET_SPOT_WS_URL: process.env.REACT_APP_MARKET_SPOT_WS_URL,
  MARKET_FUTURES_WS_URL: process.env.REACT_APP_MARKET_FUTURES_WS_URL,
  MARKET_SPOT_REST_URL: process.env.REACT_APP_MARKET_SPOT_REST_URL,
  MARKET_FUTURES_REST_URL: process.env.REACT_APP_MARKET_FUTURES_REST_URL,
  SENTRY_DSN:
    process.env.REACT_APP_SENTRY_DSN ||
    'https://4ccdc74502a78a5854d76b6991314306@o4510352626745344.ingest.de.sentry.io/4510352632643664',
  SENTRY_ENVIRONMENT: process.env.REACT_APP_SENTRY_ENVIRONMENT,
  SENTRY_RELEASE: process.env.REACT_APP_SENTRY_RELEASE,
  SENTRY_TRACES_SAMPLE_RATE: process.env.REACT_APP_SENTRY_TRACES_SAMPLE_RATE,
  SENTRY_REPLAY_SESSION_SAMPLE_RATE: process.env.REACT_APP_SENTRY_REPLAY_SESSION_SAMPLE_RATE,
  SENTRY_REPLAY_ERROR_SAMPLE_RATE: process.env.REACT_APP_SENTRY_REPLAY_ERROR_SAMPLE_RATE,
};
